const contractsMap = new Map();
const widgetContractMap = new Map();
const debugContractMap = new Map();
const addContract = (contracts, map) => {
  contracts === null || contracts === void 0 || contracts.forEach(contract => {
    map.set(`${contract.namespaceId}.${contract.name}`, contract);
  });
};
export function collectContract(contracts) {
  addContract(contracts, contractsMap);
}
export function collectWidgetContract(contracts) {
  addContract(contracts, widgetContractMap);
}
export function clearCollectWidgetContract() {
  widgetContractMap.clear();
}
export function collectDebugContract(contracts) {
  addContract(contracts, debugContractMap);
}
export function clearDebugContract() {
  debugContractMap.clear();
}
export function getContract(name) {
  return contractsMap.get(name) || widgetContractMap.get(name) || debugContractMap.get(name);
}
//# sourceMappingURL=CollectContracts.js.map